<div class="deal-container" *ngIf="deal">
  <app-deal-alerts [dealId]="deal.id"></app-deal-alerts>
  <div
    class="tw-w-full"
    [ngClass]="{
    'tw-flex tw-justify-between': showDealRightColumn
  }">
    <div [ngClass]="{
      'deal-left-col': showDealRightColumn
    }">
      <div class="deal-block">
        <!-- ACTIVE DEALS APPROVALS VIEW -->
        <div class="tw-my-4">
          <h3>Approvals</h3>
          <div *ngIf="approvalsLoading else nonLoading" class="loading-container">
            <mat-spinner diameter="24" class="loading-options"></mat-spinner>
            <div class="loading-text"> Loading Approvals...</div>
          </div>
          <ng-template #nonLoading>
            <ng-container *ngIf="approvals?.length else empty">
              <div *ngFor="let approval of approvals; let index = index;">
                <app-approval-smart
                  [readOnly]="readOnly"
                  [approvalsCount]="approvals.length"
                  [approval]="approval"
                  [useStoreApprovals]="false"
                ></app-approval-smart>
                <ng-container *ngIf="offerOptions && offerOptions.length">
                  <ng-container *ngFor="let option of offerOptions; index as i;">
                    <offer-option *ngIf="approval.id === option.approvalId"
                      [option]="option"
                      [optionType]="'approval'"
                      [cardExpandable]="true"
                    >
                    </offer-option>
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>
            <ng-template #empty>
              <div *ngIf="approvals?.length === 0">
                <p class="no-offers tw-pt-10">No Approvals Yet</p>
              </div>
            </ng-template>
          </ng-template>
        </div>

        <app-offer-smart
          [dealId]="deal.id"
          [borrowerId]="deal.borrowerId"
          [dealStage]="deal.stage"
          [loanProductType]="deal.loan_product.type"
          [readOnly]="readOnly"
        >
        </app-offer-smart>

        <!-- HISTORY DEALS APPROVALS VIEW -->
        <div *ngIf="!(deal.stage !== 'inactive' && deal.stage !== 'funded')">
          <div class="tw-my-4">
            <div *ngIf="(approvalsLoading$ | async) else nonLoading">
              <h3 class="mb-0 mt-4">Approval Calculators</h3>
              <div class="loading-container">
                <mat-spinner diameter="24" class="mr-2"></mat-spinner>
                <div class="loading-text">Loading Approvals...</div>
              </div>
            </div>
            <ng-template #nonLoading>
              <ng-container *ngIf="approvals && approvals.length else empty">
                <h3 class="mb-0 mt-4">Approval Calculators</h3>
                <div *ngFor="let approval of approvals; let index = index;">
                  <app-approval-smart
                    [readOnly]="readOnly"
                    [approvalsCount]="approvals.length"
                    [approval]="approval"
                    [useStoreApprovals]="false"
                    [hideCreateOptionButton]="true"
                  ></app-approval-smart>
                </div>
              </ng-container>
              <ng-template #empty>
                <div *ngIf="approvals && approvals.length === 0">
                  <p class="no-offers tw-pt-10">No Approvals Yet</p>
                </div>
              </ng-template>
            </ng-template>
          </div>
        </div>

      </div>

      <div
        *ngIf="deal.funded_loan_status"
        class="deal-bottom-block">
        <app-deal-loan-status [deal]="deal"></app-deal-loan-status>
      </div>
      <div class="deal-bottom-block" *ngIf="applications">
        <app-deal-timeline-smart
          [dealId]="deal.id"
          [dealCreateTimeStamp]="deal.created"
          [dealApplications]="applications"
          [closerId] = "deal.closedBy"
          [closerName]="closer()"
          >
        </app-deal-timeline-smart>
      </div>
      <div class="deal-bottom-block">
        <app-deal-owner-smart
          [deal]="deal"
          [readOnly]="readOnly"
        ></app-deal-owner-smart>
      </div>
      <div class="deal-bottom-block">
        <app-deal-details-smart [deal]="deal" [approvals]="approvals"></app-deal-details-smart>
      </div>
    </div>
    <div *ngIf="showDealRightColumn" class="deal-right-col">
      <div class="deal-block app-status" *ngIf="deal.stage !== 'funded' && deal.stage !== 'inactive'">
        <app-deal-app-status-smart [loadingStatus]="appQuestionsLoading" [questionListStatus]="questions" [deal]="deal"
          [borrowerId]="deal.borrowerId">
        </app-deal-app-status-smart>
      </div>
      <div class="deal-block">
        <app-deal-document-smart
          [deal]="deal"
          [readOnly]="readOnly"
        ></app-deal-document-smart>
      </div>
      <div *ngIf="approvals?.length" class="deal-block">
        <div *ngFor="let approval of approvals; let index = index;">
          <h2>{{approval.name}}</h2>
          <div class="tw-text-lg tw-mb-2">Stipulations</div>
          <div class="tw-pl-6 tw-mb-2">
            <ul [style.listStyle]="'disc'" class="approval-stipulations" >
              <li *ngFor="let nonConditional of approval.requestNames.nonConditional"> {{ nonConditional }} </li>
              <li *ngFor="let conditional of approval.requestNames.conditional"
                  [ngClass]="{'text-opacity-50': (amount < conditional.minAmount)}">
                {{ conditional.name }} ({{ conditional.minAmount | currency }}+)
              </li>
            </ul>
          </div>
          <div class="tw-text-lg tw-mb-2">Notes</div>
          <div class="tw-mb-2">
            {{ approval.notes }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="actions-row" *ngIf="!readOnly && applications && offers && (deal.stage !== 'inactive' || canReactivateDeals)">
    <div class="action-left-col"></div>
    <div class="action-right-col">
      <app-deal-actions-smart
        [deal]="deal"
        [offers]="offers"
        [applications]="applications"
        [bulkSubmitting]="bulkSubmitting"
        (submit)="submit.emit($event)">
      </app-deal-actions-smart>
    </div>
  </div>
</div>
